document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.variant-color-swatches');
  if (!container) return;

  const label = container.querySelector('p');
  label.style.fontSize = '1.6rem';
label.style.fontWeight = '500';
  if (!label) return;

  function findActiveByBorder() {
    const buttons = container.querySelectorAll('.color-swatch');
    for (const btn of buttons) {
      const borderColor = window.getComputedStyle(btn).borderColor;
      if (borderColor === 'rgb(0, 0, 0)') return btn;
    }
    return null;
  }

  function updateLabel(btn) {
    label.textContent = btn && btn.title ? 'Farbe: ' + btn.title : 'Farbe';
  }

  setTimeout(function () {
    updateLabel(findActiveByBorder());
  }, 300);

  container.addEventListener('click', function (e) {
    const btn = e.target.closest('.color-swatch');
    if (btn) {
      setTimeout(function () {
        updateLabel(findActiveByBorder());
      }, 100);
    }
  });
});
